import React from 'react';
import PropTypes from 'prop-types';
import './FilterTag.scss';
function FilterTag(_ref) {
  var options = _ref.options,
    handleChange = _ref.handleChange,
    selected = _ref.selected;
  return /*#__PURE__*/React.createElement("div", {
    className: "filter-tag-container"
  }, options.map(function (option) {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", {
      className: "btn btn-secondary filter-tag ".concat(option.value, " ").concat(selected === option.value ? 'filtertag-selected' : ''),
      htmlFor: "tag-radio-".concat(option.value)
    }, option.title), /*#__PURE__*/React.createElement("input", {
      type: "radio",
      className: "btn-check",
      name: "tag-radio",
      id: "tag-radio-".concat(option.value),
      value: option.value,
      onChange: function onChange() {
        return handleChange(option.value);
      },
      checked: selected === option.value
    }));
  }));
}
FilterTag.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  handleChange: PropTypes.func.isRequired,
  selected: PropTypes.string
};
FilterTag.defaultProps = {
  selected: null
};
export default FilterTag;